import cn from "classnames"

import style from "./style.module.scss"

import { Collapsible } from "components/Collapsible"
import { Text } from "ui-kit/components-branded/Text"
import { Text as OldText } from "components"

interface Props {
    title?: string
    items: string[]
    collapseAfter: number
    className?: string
}

export function BulletList({ title, items, collapseAfter, className }: Props) {
    return (
        <>
            {items.length > 0 && (
                <div className={className}>
                    {title && (
                        <Text className={cn(style.title, "pl-3")} isAccent>
                            {title}
                        </Text>
                    )}
                    <Collapsible
                        collapsible={Boolean(collapseAfter && items.length > collapseAfter)}
                        as={(props) => (
                            <div className="pl-3">
                                <Collapsible.DefaultButton {...props} />
                            </div>
                        )}
                        renderList={(collapsed) => {
                            const visibleItems = collapsed ? items.slice(0, collapseAfter) : items

                            return (
                                <ul className="list-disc pl-3">
                                    {visibleItems.map((item, index) => (
                                        <li
                                            key={index}
                                            className={cn(
                                                {
                                                    "mb-2": index !== visibleItems.length - 1,
                                                },
                                                "color-green-2"
                                            )}
                                        >
                                            <OldText color="blue-4">{item}</OldText>
                                        </li>
                                    ))}
                                </ul>
                            )
                        }}
                    />
                </div>
            )}
        </>
    )
}
